import React from 'react';
import Dvr from 'material-ui/svg-icons/device/dvr';
import ReportProblem from 'material-ui/svg-icons/action/report-problem';
import ButtonDialog from '@its/components/lib/Presentational components/ButtonDialog/ButtonDialog';
import Department from 'material-ui/svg-icons/social/location-city';
import { push } from 'react-router-redux';
import {
  sortByProp,
  sortByProps,
} from '@its/util';
import {
  listBuilder,
} from '@its/components/lib/Container components/ListContainer/ListContainer';
import {
  setDisplays,
  setDisplayList,
  setSelectedDisplay,
  setDisplayListFilter,
} from '../../redux/display/actions';
import {
  setTemplates,
  setTemplateList,
} from '../../redux/template/actions';
import {
  setTimers,
  setTimerList,
} from '../../redux/timer/actions';
import {
  setPlugins,
  setPluginList,
} from '../../redux/plugin/actions';
import {
  setDepartments,
  setDepartmentList,
  setDepartmentFilterList,
} from '../../redux/department/actions';
import { allPluralText } from '@its/components/lib/util/i18n';

const sortByIterationTime = sortByProp.bind(null, 'iterationTimer');

export const frameField = /^_\d{1,}_\d{1,}$/;
export const frameIteration = /^_\d{1,}_iterationId$/;
export const frameButton = /^_\d{1,}_setFrame$/;
export const frameId = /^_\d{1,}_setFramePosition$/;

export const displayListAppBar = (() => {
  const List = listBuilder((state) => ({
    endSpace: false,
    items: state.app.departments.filterList,
  }));
  return {
    title: 'DISPLAYS',
    navigateBack: false,
    iconElementRight: (
      <ButtonDialog
        type="icon"
        icon="filter_list"
        iconStyle={{ color: '#FFFFFF' }}
        dialog={ {
          title: 'DEPARTMENT',
          cancel: true,
          content: <List />,
          autoScrollBodyContent: true,
        } }
      />
    ),
  };
})();

export const getDisplayList = (dispatch, displays, props) => {
  const result = {
    title: 'DISPLAYS',
    currentFilter: null,
    items: [],
  };
  result.items = displays.map((display) => {
    let rightIcon = null;
    if (display.offLineOn_LAN1 || display.offLineOn_LAN2) {
      rightIcon = <ReportProblem />;
    }
    return {
      key: display.id,
      icon: <Dvr />,
      primaryText: display.name,
      secondaryText: display.shortDescription,
      rightIcon,
      filter: display.departmentId,
      editable: false,
      deletable: false,
      onTouchTap: () => {
        dispatch(setSelectedDisplay(display));
        if (props.navigate) {
          dispatch(push('/display'));
        }
      },
    };
  });
  return result;
};

const getTemplateList = (templates) => {
  const result = [];
  for (const template of templates) {
    result.push({
      value: template.id,
      primaryText: template.shortDescription,
    });
  }
  return result;
};

const getTimerList = (iterations) => {
  const result = [];
  iterations = iterations.sort(sortByIterationTime);
  for (const iteration of iterations) {
    result.push({
      value: iteration.id,
      primaryText: iteration.name,
    });
  }
  return result;
};

const getPluginList = (plugins) => {
  const result = [];
  for (const plugin of plugins) {
    result.push({
      value: plugin.id,
      primaryText: plugin.description,
    });
  }
  return result;
};

const getDepartmentFilterList = (dispatch, departments) => {
  const result = [{
    key: 'all',
    icon: <Department />,
    primaryText: allPluralText,
    onTouchTap: () => {
      dispatch(setDisplayListFilter(null));
    },
  }];
  for (let i = 0; i < departments.length; i++) {
    result.push({
      key: departments[i].id,
      icon: <Department />,
      primaryText: departments[i].name,
      onTouchTap: () => {
        dispatch(setDisplayListFilter(departments[i].id));
      },
    });
  }
  return result;
};

const getDepartmentList = (departments) => {
  const result = [];
  for (const department of departments) {
    result.push({
      value: department.id,
      primaryText: department.name,
    });
  }
  return result;
};

export const onSuccess = (data, dispatch, props) => {
  dispatch(setDisplays(data[0].body.resultSet));
  dispatch(setDisplayList(getDisplayList(dispatch, data[0].body.resultSet, props)));
  handleDepartmentList(data[1], dispatch);
};

export const sortByRowNum = sortByProps.bind(null, 'rowNum', 'fieldNum');

export const getFirstLineDisplayMap = (displayMaps, id) => {
  for (const i in displayMaps) {
    if (displayMaps[i].displayTemplatesMapId === id && displayMaps[i].frame === 1) {
      return displayMaps[i];
    }
  }
  return {};
};

export const getDisplayMaps = (displayMaps, id) => {
  const result = [];
  for (const i in displayMaps) {
    if (displayMaps[i].displayTemplatesMapId === id) {
      result.push(displayMaps[i]);
    }
  }
  return result;
};

const handleList = (get, set, setList, data, dispatch) => {
  const list = get(data.body.resultSet);
  dispatch(set(data.body.resultSet));
  dispatch(setList(list));
  return list;
};

export const handleTemplateList = handleList.bind(null, getTemplateList, setTemplates, setTemplateList);
export const handleTimerList = handleList.bind(null, getTimerList, setTimers, setTimerList);
export const handlePluginList = handleList.bind(null, getPluginList, setPlugins, setPluginList);
export const handleDepartmentList = (data, dispatch) => {
  const departmentList = handleList(getDepartmentList, setDepartments, setDepartmentList, data, dispatch);
  dispatch(setDepartmentFilterList(getDepartmentFilterList(dispatch, data.body.resultSet)));
  return departmentList;
};



/** WEBPACK FOOTER **
 ** ./src/routes/Display/util.js
 **/